<template>
  <TemplateBase>
    <main class="relative z-0 col-span-full row-start-2" :class="{ 'xl:row-start-1': page.image }">
      <!-- Header -->
      <MoleculeHeaderOverview
        class="mb-8 sm:mb-12 md:mb-8"
        :title="page.title"
        :subtitle="page.subtitle"
        :introduction="page.introduction"
        :image="page.image"
        :class="{ 'mt-16 lg:mt-20': !page.image }"
      />
      <OrganismNavigationBreadcrumb
        class="container absolute z-30 top-0 2xl:-mt-16 mx-auto p-4 md:relative md:mb-16 md:px-8 md:py-0 lg:mb-20"
        :path="breadcrumbs"
        :dark-mode-mobile="!!page.image"
      />

      <!-- Overview section with cards -->
      <section id="overview-page-card-overview" class="container mx-auto px-6 sm:px-8">
        <ul>
          <li v-for="(item, index) in page.items" :key="index" class="mb-6">
            <h3 class="mb-3 text-lg font-bold leading-4 uppercase sm:mb-5 sm:text-2xl md:text-3xl text-black">
              {{ item.label }}
            </h3>
            <ul class="grid gap-y-4 grid-cols-1 2xl:grid-cols-4 mb-6 sm:gap-x-8 sm:gap-y-10 sm:grid-cols-2 lg:grid-cols-3 lg:mb-16">
              <li v-for="(child, childIndex) in item.children" :key="childIndex" class="flex">
                <MoleculeCardOverview :url="child.url" :title="child.title" :subtitle="child.subtitle" :image="child.image" :img-alt="child.title" />
              </li>
            </ul>
          </li>
        </ul>
      </section>

      <section v-if="page.donationReference && page.donationReference.url" id="overview-page-donation" class="container relative z-10 mb-16 mx-auto 2xl:px-56 px-6 sm:px-8">
        <div class="relative">
          <MoleculePicture :image="page.donationReference.image" class="cover-fill hidden w-full h-full lg:block" />
          <div class="bottom-0 right-0 w-full lg:absolute lg:max-w-xl">
            <MoleculeDonation
              :title="page.donationReference.title"
              :subtitle="page.donationReference.subtitle"
              :introduction="page.donationReference.introduction"
              :image="page.donationReference.image"
              :url="page.donationReference.url"
              :price1="page.donationReference.donationPrice1"
              :price2="page.donationReference.donationPrice2"
              :price3="page.donationReference.donationPrice3"
            />
          </div>
        </div>
      </section>
    </main>
  </TemplateBase>
</template>

<script setup lang="ts">
interface Page {
  title: string
  subtitle: string
  introduction: string
  image: string | null
  items: Array<{
    label: string
    children: Array<{
      url: string
      title: string
      subtitle: string
      image: string
    }>
  }>
  donationReference?: {
    title: string
    subtitle: string
    introduction: string
    image: string
    url: string
    donationPrice1: number
    donationPrice2: number
    donationPrice3: number
  }
}

interface Props {
  breadcrumbs: Array<any> // Type of items in breadcrumbs is unknown, assuming any
  page: Page
}

defineProps<Props>()
</script>
